---
de:
  rows:
    connection: verbindung
    connections: verbindungen
  suppliers:
    add_supplier: Lieferant hinzufügen
    categories:
      advisor_commercial: Kaufmännischer Berater
      advisor_legal: Rechtlicher Berater
      advisor_mna: M&A Berater
      advisor_technical: Technischer Berater
      association: Verein
      consultant: Berater
      electricity_company: Elektrizitätswerk
      entrepreneur: Unternehmer
      equipment_supplier: Ausrüstungslieferant
      finance: Finanz
      grid_owner: Netzeigentümer
      insurance: Versicherung
      investor: Investor
      journalist: Journalist
      operation_and_maintenance: Betrieb & Wartung
      other: Sonstiges
      power_trader: Stromhändler
      risk_management: Risikomanagement
      student: Student
      telecommunication: Telekommunikation
    category: Kategorie
    roles:
      control_system: Steuerungssystem
      generator: Generator
      turbine: Turbine
    supplier: Lieferant
    supplier_created: Lieferant erstellt
    supplier_role: Lieferantenrolle
    supplier_updated: Lieferant aktualisiert
    suppliers: Lieferanten
    url_facebook: Facebook
    url_homepage: Webseite
    url_instagram: Instagram
    url_linked_in: LinkedIn
